export default function imageGeneral() {
  return {
    _id: false,
    type: 'droplet.imageGeneral',
    src: `${process.env.S3_ASSETS_URL}mock-images/default-images/drp-imageGeneral-image.png`,
    originalFile: 'drp-imageGeneral-image.png',
    altText: false,
    hasLink: false,
    newWindow: false,
    pageLink: false,
    customLink: false,
    mediaQueries: [],
    pageCSS: '',
    firstDrop: true,
    ref: null,
    siteType: null,
    latestDynamic: false,
    uploadTouched: false,
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/image-general/droplet.schema.js